<i18n src="@/locales/modules/TitleTranslate.json"></i18n>

<template>
	<div>
		<el-dialog append-to-body destroy-on-close class="custom-dialog" :visible.sync="isSidebarActiveLocal" :before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)">
			<div slot="title">
				<h4 class="uppercase font-bold block text-xl w-full">{{ $t("Title") }}</h4>
				<p class="text-base text-black font-medium">{{ role.name }}</p>
			</div>
			<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list">
				<div class="px-8 py-4">
					<AddTitle @onDelete="handleDeleteTitle" v-model="titles" />
				</div>
			</perfect-scrollbar>

			<div class="flex justify-center flex-wrap items-center" slot="footer">
				<vs-button class="w-full sm:w-1/3 mb-3 sm:mb-0 sm:mr-6 font-bold" :disabled="!(titles && titles.length)" @click.stop="saveTitle">
					{{ $t("Actions.Save") }}
				</vs-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as _ from "lodash";
import { showConfirm, detectLeavePage } from "@/mixins/mixins.js";

import AddTitle from "@/components/add-title-with-department-for-role/AddTitle";

export default {
	name: "TitlesByRoleDialog",
	mixins: [showConfirm, detectLeavePage("isFormDirty")],

	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		role: {
			type: Object,
			required: true
		},
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	components: { AddTitle },
	data() {
		return {
			titles: [],
			isFormDirty: false,
			initTitles: []
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		isHasUnsavedTitle() {
			return !!this.titles.find(title => !title.id);
		},
		trackingIsFormDirtyData() {
			return { titles: this.titles, initTitles: this.initTitles };
		}
	},
	watch: {
		trackingIsFormDirtyData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal.titles) !== JSON.stringify(newVal.initTitles) || this.isHasUnsavedTitle;
			},
			deep: true
		}
	},
	methods: {
		async saveTitle() {
			const result = await this.$validator.validateAll();
			if (!result) return;
			this.$vs.loading();
			const list = this.titles.map(title => {
				let item = {
					name: title.name,
					role_id: this.role.id
				};
				if (title.id) {
					item.id = title.id;
				}
				return item;
			});

			const payload = {
				list
			};
			try {
				const response = await this.$store.dispatch("titleManagement/bulkUpdateTitles", payload);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("UpdateTitleSuccessful")
					}
				});

				this.titles = response && response.titles ? response.titles : [];
				this.initTitles = _.cloneDeep(this.titles);
				this.$emit("onUpdateTitleSuccess");
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleDeleteTitle(titleItem = {}, deleteIndex) {
			try {
				if (titleItem.id) {
					this.mixinShowConfirm().then(async isAccept => {
						if (isAccept) {
							await this.$store.dispatch("titleManagement/deleteTitle", { id: titleItem.id });
							this.titles = this.titles.filter(title => title.id !== titleItem.id);
							this.initTitles = _.cloneDeep(this.titles);
							this.$helper.notifySuccess({
								context: this,
								options: {
									text: this.$t("DeleteTitleSuccessful")
								}
							});
							this.$emit("onUpdateTitleSuccess");
						}
					});
				} else {
					this.titles = this.titles.filter((title, index) => index !== deleteIndex);
					this.initTitles = _.cloneDeep(this.titles);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		}
	},
	created() {
		this.titles = this.role.titles;
		this.initTitles = _.cloneDeep(this.role.titles);
	}
};
</script>

<style></style>
